import type { ReactElement } from 'react'
import { useField } from 'formik'

import RadioButtonGroup from '../../../../formComponents/FormikRadioButtonField'

type Props = TranslateProps
export function ProductLayout({ t }: Props): ReactElement {
  const [{ value: productId }] = useField('productId')
  const disabled = !productId

  return (
    <div className="dali-settingslayer-productshowcase-layout">
      <fieldset disabled={disabled}>
        <legend>{t('layoutSetting.label')}</legend>
        <RadioButtonGroup
          name="layout"
          disabled={disabled}
          options={[
            { value: 'detailed', label: t('layoutSetting.detailedRadioButton.label') },
            { value: 'simple', label: t('layoutSetting.simpleRadioButton.label') },
          ]}
        />
      </fieldset>
    </div>
  )
}
